export const dataServiceChangeSchema = {
  title: 'Data Service Change',
  type: 'object',
  properties: {
    mpan_core: {
      type: 'object',
      title: 'MPAN Core',
      properties: {
        name: { type: 'string' },
        marketSector: { type: ['string', 'null'] },
      },
      required: ['name'],
    },
    data_service_mpid: {
      type: 'string',
      title: 'Data Service MPID',
    },
    effective_from: {
      type: 'string',
      format: 'date',
      title: 'Effective From',
    },
    appointment_scenario: {
      type: 'string',
      title: 'Appointment Scenario',
      enum: ['COS', 'CSP', 'USP', 'SEG', 'MCA', 'MCS'],
      enumNames: [
        'COS – Change of Supplier',
        'CSP – Change of Supplier and Party',
        'USP – Unregistered Site Process',
        'SEG – Segment Exchange',
        'MCA – Metering Contract Appointment',
        'MCS – Metering Contract Switch',
      ],
    },
    consent_granularity: {
      type: 'string',
      title: 'Consent Granularity',
      enum: ['H', 'D', 'M', 'N'],
      enumNames: ['H - Hourly', 'D - Daily', 'M - Monthly', 'N - None'],
    },
  },
  required: ['mpan_core', 'data_service_mpid', 'effective_from', 'appointment_scenario', 'consent_granularity'],
};

export const dataServiceChangeUISchema = {
  mpan_core: {
    'ui:placeholder': 'Select MPAN',
    'ui:options': { label: true },
    name: { 'ui:widget': 'hidden' },
    marketSector: { 'ui:widget': 'hidden' },
  },
  data_service_mpid: {
    'ui:placeholder': 'Select Data Service Provider',
  },
  effective_from: {
    'ui:widget': 'date',
    'ui:placeholder': 'Select effective date',
  },
  appointment_scenario: {
    'ui:placeholder': 'Select appointment scenario',
  },
  consent_granularity: {
    'ui:placeholder': 'Select consent granularity',
  },
};
